export class NavigationDrawer {
    constructor() {
        this.drawer = document.querySelector('.js-navigation-drawer');
        this.trigger = document.querySelectorAll('.js-nav-open-button');
        this.closeButtons = document.querySelectorAll('.js-navigation-drawer-close');
        this.backdrop = document.querySelector('.js-navigation-drawer-backdrop');
        this.isOpen = false;

        this.init();
    }

    init() {
        if (!this.drawer) return;

        this.trigger.forEach(btn => {
            btn.addEventListener('click', () => this.open());
        });

        this.closeButtons.forEach(btn => {
            btn.addEventListener('click', () => this.close());
        });

        if (this.backdrop) {
            this.backdrop.addEventListener('click', () => this.close());
        }

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });
    }

    open() {
        this.isOpen = true;
        this.drawer.classList.add('is-open');
        document.body.classList.add('nav-open');
    }

    close() {
        this.isOpen = false;
        this.drawer.classList.remove('is-open');
        document.body.classList.remove('nav-open');
    }
}
